import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DataClientService } from 'src/app/services/data-client.service';
import { ParentCallerService, ParentRequest, OutputValues } from 'src/app/services/parent-caller.service';
import { Store } from '@ngrx/store';
import { OnboardingProductsStore } from '../../../store/store';
import { StepsClientTypes } from 'src/app/shared/enums';
import { UiActions } from 'src/app/store/actions';
import { environment } from 'src/environments/environment';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
  selector: 'app-update-data',
  templateUrl: './update-data.component.html',
  styleUrls: ['../../../global.scss', './update-data.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UpdateDataComponent implements OnInit {

  jointAccountWithoutInfo: boolean;
  staticAssetsUrl = environment.staticScripts.staticAssets;
  constructor(
    private store: Store<OnboardingProductsStore.AppState>,
    private parentCallerService: ParentCallerService,
    public loadingService: LoadingService,
    private dataClientService: DataClientService) { }

  ngOnInit() {
    setTimeout(() => {
      this.loadingService.loading = false;
    }, 100);
    this.jointAccountWithoutInfo = this.dataClientService.getJointAccountWithoutInfo();
  }

  updateData() {
    const request: ParentRequest = {
      operation: OutputValues.DATA_ACTUALIZATION,
      request: {}
    };
    this.parentCallerService.callParent(request);
  }
  back() {
    this.store.dispatch(UiActions.Navigate({ step: StepsClientTypes.STEP_PRIVATE_LANDING_JOINT }));
  }
}
